















import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import ProfileWidget from "@/views/users/ProfileWidget.vue";
import PortfolioWidget from "@/views/policies/PortfolioWidget.vue";
import FactFindWidget from "@/views/factFind/FactFindWidget.vue";
import BackButton from "@/components/BackButton.vue";

@Component({
  components: {
    ProfileWidget,
    PortfolioWidget,
    FactFindWidget,
    BackButton
  }
})
export default class AdvisorClientView extends Vue {
  contactId: number = 0;

  async created() {
    this.contactId = parseInt(this.$route.params.contactId);
  }
}
